import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 44029D6D-5640-4AE5-907B-8388B0438FF0
 * name contain
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/contain.svg
 * tags
 */
export const ContainIcon = createSvgIcon(<><path d="M2,3H8V5H4V19H8V21H2V3M7,17V15H9V17H7M11,17V15H13V17H11M15,17V15H17V17H15M22,3V21H16V19H20V5H16V3H22Z" /></>, 'ContainIcon');
export default ContainIcon